import React from 'react';
import styled, { css } from 'styled-components';
import { InfoBanner, Link } from '@sparknz/spark-pattern-library';

import { useAuthorableContents } from 'shared/providers/AuthorableContentsProvider';

const ErrorLink = styled(Link)`
  ${({ theme: { palette } }) => css`
    color: ${palette.baseColors.karaka};
    :visited {
      color: ${palette.baseColors.karaka};
      background-color: transparent;
    }
    :hover,
    :active {
      color: ${palette.grayScale1};
      background-color: ${palette.baseColors.karaka};
    }
  `}
`;

interface ErrorBannerProps {
  errorContentKey: string;
  linkContentKey?: string;
}

const ErrorBanner = ({ errorContentKey, linkContentKey }: ErrorBannerProps) => {
  const { getLink, getText } = useAuthorableContents();
  return (
    <InfoBanner variant="ERROR">
      {getText(errorContentKey)}
      {linkContentKey ? (
        <ErrorLink href={getLink(linkContentKey)}>
          {getText(linkContentKey)}
        </ErrorLink>
      ) : null}
    </InfoBanner>
  );
};

export default ErrorBanner;
